<ion-header>
    <ion-toolbar>
        <ion-title>
        </ion-title>
    </ion-toolbar>

</ion-header>
<ion-content>
    <ion-card>
        <!-- <ion-card-header>
            <ion-card-title>
                Przykładowa Galeria
            </ion-card-title>
        </ion-card-header> -->
        <ion-card-content>
            <iframe [src]="url" frameborder="0" allowfullscreen style="width: 100%; height: 85vh;"></iframe>
        </ion-card-content>
    </ion-card>
</ion-content>